import { EnvironmentProviders, importProvidersFrom, Injectable, makeEnvironmentProviders } from '@angular/core';
import { TranslateDefaultParser, TranslateLoader, TranslateModule, TranslateParser } from '@ngx-translate/core';
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DEFAULT_LANGUAGE, LANGUAGE_CODES } from './i18n.constants';
import { I18nService } from './i18n.service';

@Injectable()
export class BraceTranslateParser extends TranslateDefaultParser {
  override interpolate(expr: string, params?: object): string {
    if (typeof expr !== 'string' || !params) {
      return expr;
    }

    let result = super.interpolate(expr, params) ?? expr;
    for (const [rawKey, value] of Object.entries(params)) {
      const key = rawKey.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`\\{${key}\\}`, 'g');
      result = result.replace(regex, () => String(value ?? ''));
    }
    return result;
  }
}

export function provideI18n(): EnvironmentProviders {
  return makeEnvironmentProviders([
    I18nService,
    { provide: TRANSLATE_HTTP_LOADER_CONFIG, useValue: { prefix: 'assets/i18n/', suffix: '.json' } },
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: { provide: TranslateLoader, useClass: TranslateHttpLoader },
        parser: { provide: TranslateParser, useClass: BraceTranslateParser },
        defaultLanguage: LANGUAGE_CODES[DEFAULT_LANGUAGE],
      }),
    ),
  ]);
}
